import React from 'react'
import { withComponentLabel } from '../utils/debug'

// Tailwind modal shell; visibility is controlled by the parent via `open`.
function Modal(props) {
  const { modalContent, modalId, header, open, onClose } = props

  if (!open) return null

  return (
    <div
      id={modalId}
      className="fixed inset-0 z-50 flex items-start justify-center bg-black/70 pt-16"
      onClick={onClose}
    >
      <div
        className="w-11/12 max-w-md rounded-xl bg-slate-100 text-slate-700 shadow-xl"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="max-h-[60vh] overflow-y-auto p-6">
          {header}
          <div className="mt-2">{modalContent}</div>
        </div>
        <div className="flex justify-end gap-2 border-t border-slate-300 p-3">
          {props.children}
        </div>
      </div>
    </div>
  )
}

export default withComponentLabel(Modal, 'Modal')
